import { CubePresenter, FlipIntent, Logger } from 'wdc-cube'

import { AttrIds, Places } from 'src/Constants'
import { MainPresenter } from 'src/main/Main.presenter'
import cfopService from 'src/modules/motor-credito/cfop/cfop.service'
import { CondicaoRow } from '../regra.types'
import { RegraFormKeys } from '../regra_form.keys'
import RegraFormScope from '../regra_form.scopes'
import condicaoService from './condicao.service'
import { CondicaoFormKeys } from './condicao_form.keys'
import CondicaoFormScope from './condicao_form.scopes'

const LOG = Logger.get('CondicaoFormPresenter')

export class CondicaoFormPresenter extends CubePresenter<MainPresenter, CondicaoFormScope> {
    // :: Constructor
    public constructor(app: MainPresenter) {
        super(app, new CondicaoFormScope())
    }

    // :: Instance
    #condicaoId?: number
    #analiseId?: number
    #regraId?: number

    // :: Methods

    buscarCondicaoSelecionada = async () => {
        if (!this.#analiseId || !this.#regraId || !this.#condicaoId || this.#condicaoId < 0) return

        const condicao = await condicaoService.fetchCondicaoInfo(this.#analiseId, this.#regraId, this.#condicaoId)
        if (condicao) {
            this.scope.idSelected = condicao.id!
            this.scope.fonteDados = condicao.fonteDados
            this.scope.campoFonteDados = condicao.campoFonteDados
            this.scope.comparacao = condicao.comparacao
            this.scope.valor1 = condicao.valor1
            this.scope.valor2 = condicao.valor2
            this.scope.tipo = condicao.tipo
        }
    }

    public override release() {
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new CondicaoFormKeys(this.app, intent)

        this.#analiseId = keys.analiseId
        this.#regraId = keys.regraId

        keys.dialogSlot(this.scope)

        LOG.debug(`applyParameters ${keys.condicaoId}`)
        if (initialization) {
            await this.#initialize()
            if (keys.condicaoId) {
                this.#condicaoId = keys.condicaoId
                if (this.#condicaoId < 0) {
                    const condicaoEdit = intent.attributes.get(AttrIds.mcNewNpCondicaoAttr) as CondicaoRow

                    this.scope.idSelected = this.#condicaoId
                    this.scope.fonteDados = condicaoEdit.fonteDados
                    this.scope.campoFonteDados = condicaoEdit.campoFonteDados
                    this.scope.comparacao = condicaoEdit.comparacao
                    this.scope.valor1 = condicaoEdit.valor1
                    this.scope.valor2 = condicaoEdit.valor2
                    this.scope.tipo = condicaoEdit.tipo
                } else {
                    await this.buscarCondicaoSelecionada()
                }
            }
            this.scope.cfops = await cfopService.fetchCfops()
        }

        return keys.allow
    }

    public override publishParameters(intent: FlipIntent): void {
        const keys = new CondicaoFormKeys(this.app, intent)
        keys.condicaoId = this.#condicaoId
        LOG.debug(`publishParameters ${keys.condicaoId}`)
    }

    async #initialize() {
        LOG.debug('initialize')

        this.scope.onClose = this.action(this.handleClose)

        this.scope.onSave = this.action(this.handleSave)
    }

    private async handleClose() {
        await new RegraFormKeys(this.app).flip()
    }

    private async handleSave() {
        try {
            const condicaoSave = {
                fonteDados: this.scope.fonteDados,
                campoFonteDados: this.scope.campoFonteDados,
                comparacao: this.scope.comparacao,
                valor1: this.scope.valor1,
                valor2: this.scope.valor2,
                tipo: this.scope.tipo
            }

            const newIntent = this.app.newFlipIntent(Places.mcRegraForm)

            let retSalvar = {} as CondicaoRow

            if (!this.#regraId || this.#regraId <= 0) {
                const tempId = this.#condicaoId ? this.#condicaoId : (-Math.floor(Math.random() * 1000) as number)

                retSalvar = { ...condicaoSave, id: tempId }
            } else {
                retSalvar =
                    this.scope.idSelected > 0
                        ? await condicaoService.updateCondicao(
                              this.#analiseId!,
                              this.#regraId,
                              this.scope.idSelected,
                              condicaoSave
                          )
                        : await condicaoService.saveCondicao(this.#analiseId!, this.#regraId, condicaoSave)

                if (!retSalvar) {
                    return
                }
                this.app.notify('success', 'Salvo com sucesso')
            }

            const regraFormScope = this.app.getPresenter(Places.mcRegraForm)?.scope as RegraFormScope
            if (regraFormScope) {
                regraFormScope.condicoes = [...regraFormScope.condicoes.filter((c) => c.id !== retSalvar.id), retSalvar]
            }

            const key = new RegraFormKeys(this.app, newIntent)
            await key.flip()
        } catch (caught) {
            LOG.error('handleSave', caught)
            throw caught
        }
    }
}

export default CondicaoFormPresenter
